import { NgModule } from '@angular/core';

import { LIB_CommonModule } from "pbc.angular";

import { DurchgangService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [
    DurchgangService,
  ],
  exports: []
})
export class DurchgangServiceModule { }
